import { render } from "./CreateGoonda.vue?vue&type=template&id=5213a76a"
import script from "./CreateGoonda.vue?vue&type=script&lang=js"
export * from "./CreateGoonda.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__